export default "assets/images/Logo-e67dfb3d.png";